import {
  drawer_styles_default
} from "./chunk.HSIZLXE7.js";
import {
  createPopper
} from "./chunk.A364I6JA.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  e3 as e2,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/drawer/drawer.ts
import { t } from "i18next";
var FadvDrawer = class extends s {
  constructor() {
    super(...arguments);
    this.tooltipDelay = 250;
    this.hasSlot = new HasSlotController(this, "[default]", "secondary", "start", "end");
    this.open = false;
    this.label = t("components:navigation.main");
  }
  get drawerStart() {
    return this.querySelector('fadv-drawer-start[slot="start"]');
  }
  get drawerEnd() {
    return this.querySelector('fadv-drawer-end[slot="end"]');
  }
  getMenuBases() {
    return [...this.menus].map((m) => {
      var _a;
      return (_a = m.shadowRoot) == null ? void 0 : _a.querySelector('[part="base"]');
    });
  }
  getMenuItems() {
    return [...this.querySelectorAll(":scope > fadv-menu-item, :scope > fadv-menu-item-link")].filter((e3) => hasTag(e3, "fadv-menu-item") || hasTag(e3, "fadv-menu-item-link")).map((e3) => e3);
  }
  async firstUpdated() {
    var _a, _b;
    this.handleMenuItemMouseenter = this.handleMenuItemMouseenter.bind(this);
    this.handleMenuItemMouseleave = this.handleMenuItemMouseleave.bind(this);
    await this.updateComplete;
    const items = this.getMenuItems();
    items.forEach((i2) => {
      i2.classList.add("drawer-menu-item");
      i2.classList.toggle("drawer-menu-item--open", this.open);
      i2.addEventListener("mouseenter", this.handleMenuItemMouseenter);
      i2.addEventListener("mouseleave", this.handleMenuItemMouseleave);
      i2.addEventListener("focus", this.handleMenuItemMouseenter);
      i2.addEventListener("blur", this.handleMenuItemMouseleave);
    });
    if (this.open) {
      (_a = this.drawerStart) == null ? void 0 : _a.open();
      (_b = this.drawerEnd) == null ? void 0 : _b.open();
    }
  }
  disconnectedCallback() {
    this.getMenuItems().forEach((i2) => {
      i2.removeEventListener("mouseenter", this.handleMenuItemMouseenter);
      i2.removeEventListener("mouseleave", this.handleMenuItemMouseleave);
      i2.removeEventListener("focus", this.handleMenuItemMouseenter);
      i2.removeEventListener("blur", this.handleMenuItemMouseleave);
    });
    super.disconnectedCallback();
  }
  animateOpen() {
    this.destroyTooltip();
    const menus = [...this.menus].map((m) => {
      var _a;
      return (_a = m.shadowRoot) == null ? void 0 : _a.querySelector('[part="base"]');
    });
    stopAnimations(this.drawer);
    stopAnimations(this.buttonIcon);
    menus.forEach((m) => stopAnimations(m));
    emit(this, "sl-show");
    requestAnimationFrame(async () => {
      var _a, _b;
      const drawerAnimation = getAnimation(this, "drawer.open");
      const menuAnimation = getAnimation(this, "drawer-menu.open");
      const iconAnimation = getAnimation(this, "drawer-button-icon.open");
      (_a = this.drawerStart) == null ? void 0 : _a.open();
      (_b = this.drawerEnd) == null ? void 0 : _b.open();
      this.getMenuItems().forEach((i2) => i2.classList.toggle("drawer-menu-item--open", true));
      await Promise.all([
        ...menus.map((m) => animateTo(m, menuAnimation.keyframes, menuAnimation.options)),
        animateTo(this.drawer, drawerAnimation.keyframes, drawerAnimation.options)
      ]);
      animateTo(this.buttonIcon, iconAnimation.keyframes, iconAnimation.options);
      this.open = true;
      emit(this, "sl-after-show");
    });
  }
  animateClose() {
    const menus = this.getMenuBases();
    stopAnimations(this.drawer);
    stopAnimations(this.buttonIcon);
    menus.forEach((m) => stopAnimations(m));
    emit(this, "sl-hide");
    requestAnimationFrame(async () => {
      var _a, _b;
      const drawerAnimation = getAnimation(this, "drawer.close");
      const menuAnimation = getAnimation(this, "drawer-menu.close");
      const iconAnimation = getAnimation(this, "drawer-button-icon.close");
      (_a = this.drawerStart) == null ? void 0 : _a.close();
      (_b = this.drawerEnd) == null ? void 0 : _b.close();
      this.getMenuItems().forEach((i2) => i2.classList.toggle("drawer-menu-item--open", false));
      await Promise.all([
        ...menus.map((m) => animateTo(m, menuAnimation.keyframes, menuAnimation.options)),
        animateTo(this.drawer, drawerAnimation.keyframes, drawerAnimation.options)
      ]);
      animateTo(this.buttonIcon, iconAnimation.keyframes, iconAnimation.options);
      this.open = false;
      emit(this, "sl-after-hide");
    });
  }
  toggleOpen() {
    if (this.open) {
      this.hide();
    } else {
      this.show();
    }
  }
  hide() {
    this.animateClose();
  }
  show() {
    this.animateOpen();
  }
  handleKeydown(event) {
    if (this.open && event.key === "Escape") {
      this.hide();
    }
  }
  createTooltip(target) {
    if (this.tooltipPopper) {
      this.tooltipPopper.destroy();
    }
    target.dataset.hoverState = "hovered";
    setTimeout(() => {
      if (this.open)
        return;
      if ((target == null ? void 0 : target.dataset.hoverState) !== "hovered")
        return;
      this.tooltipPopper = createPopper(target, this.tooltipPositioner, {
        placement: "right",
        strategy: "fixed",
        modifiers: [
          {
            name: "flip",
            options: {
              boundary: "viewport"
            }
          },
          {
            name: "offset",
            options: {
              offset: [0, 10]
            }
          }
        ]
      });
      this.tooltipPositioner.classList.add("drawer__tooltip-positioner--open");
      this.tooltip.textContent = target.textContent;
      this.tooltipPopper.update();
    }, this.tooltipDelay);
  }
  destroyTooltip(target) {
    if (target) {
      delete target.dataset.hoverState;
    }
    this.tooltipPositioner.classList.remove("drawer__tooltip-positioner--open");
    this.tooltip.textContent = "";
    if (this.tooltipPopper) {
      this.tooltipPopper.destroy();
    }
  }
  handleMenuItemMouseenter(event) {
    if (this.open)
      return;
    if (!["fadv-menu-item", "fadv-menu-item-link"].some((tag) => hasTag(event.target, tag)))
      return;
    const menuItem = event.target;
    if (menuItem.hasSubmenu)
      return;
    this.createTooltip(menuItem);
  }
  handleMenuItemMouseleave(event) {
    if (!["fadv-menu-item", "fadv-menu-item-link"].some((tag) => hasTag(event.target, tag)))
      return;
    const menuItem = event.target;
    delete menuItem.dataset.hoverState;
    this.destroyTooltip(menuItem);
  }
  render() {
    return $`<nav id="drawer" role="navigation" aria-label=${this.label} class=${o({
      drawer: true,
      "drawer--open": this.open,
      "drawer--has-secondary": this.hasSlot.test("secondary"),
      "drawer--has-start": this.hasSlot.test("start"),
      "drawer--has-end": this.hasSlot.test("end")
    })} @keydown=${this.handleKeydown} ><button aria-label=${t(this.open ? "components:drawer.buttonLabelOpened" : "components:drawer.buttonLabelClosed")} aria-controls="drawer" class="drawer__button" @click=${this.toggleOpen} ><fadv-icon aria-hidden="true" foreground="primary" library="solid" name="arrow-right"></fadv-icon></button><div class="drawer__body"><div class="drawer__start"><slot name="start"></slot></div><div class="drawer__primary"><fadv-menu><slot></slot></fadv-menu></div><div class="drawer__secondary"><fadv-menu><slot name="secondary"></slot></fadv-menu></div><div class="drawer__end"><slot name="end"></slot></div><div aria-hidden="true" class="drawer__tooltip-positioner"><div class="drawer__tooltip-arrow"></div><div class="drawer__tooltip"></div></div></div></nav>`;
  }
};
FadvDrawer.styles = drawer_styles_default;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvDrawer.prototype, "open", 2);
__decorateClass([
  e()
], FadvDrawer.prototype, "label", 2);
__decorateClass([
  i(".drawer")
], FadvDrawer.prototype, "drawer", 2);
__decorateClass([
  i(".drawer__button fadv-icon")
], FadvDrawer.prototype, "buttonIcon", 2);
__decorateClass([
  i(".drawer__tooltip-positioner")
], FadvDrawer.prototype, "tooltipPositioner", 2);
__decorateClass([
  i(".drawer__tooltip")
], FadvDrawer.prototype, "tooltip", 2);
__decorateClass([
  e2("fadv-menu")
], FadvDrawer.prototype, "menus", 2);
FadvDrawer = __decorateClass([
  n("fadv-drawer")
], FadvDrawer);
var duration = 300;
var easeInOptions = { duration, easing: "ease-in" };
var easeOutOptions = { duration, easing: "ease-out" };
setDefaultAnimation("drawer.open", {
  keyframes: [{ width: "50px" }, { width: "300px" }],
  options: easeOutOptions
});
setDefaultAnimation("drawer.close", {
  keyframes: [{ width: "300px" }, { width: "50px" }],
  options: easeInOptions
});
setDefaultAnimation("drawer-button-icon.open", {
  keyframes: [{ transform: "rotate(0deg)" }, { transform: "rotate(180deg)" }],
  options: easeOutOptions
});
setDefaultAnimation("drawer-button-icon.close", {
  keyframes: [{ transform: "rotate(180deg)" }, { transform: "rotate(360deg)" }],
  options: easeInOptions
});
setDefaultAnimation("drawer-menu.open", {
  keyframes: [
    { paddingLeft: "var(--sl-spacing-3x-small)", paddingRight: "var(--sl-spacing-3x-small)" },
    { paddingLeft: "var(--sl-spacing-small)", paddingRight: "var(--sl-spacing-small)" }
  ],
  options: easeOutOptions
});
setDefaultAnimation("drawer-menu.close", {
  keyframes: [
    { paddingLeft: "var(--sl-spacing-small)", paddingRight: "var(--sl-spacing-small)" },
    { paddingLeft: "var(--sl-spacing-3x-small)", paddingRight: "var(--sl-spacing-3x-small)" }
  ],
  options: easeOutOptions
});

export {
  FadvDrawer
};
